import FilterIndicator from 'Components/Generic/Misc/FilterIndicator';
import { SITE_PAGES } from 'Config';
import ChargeAllocationData from 'Data/ChargeAllocationData';
import { useGlobalState } from 'Data/context/GlobalState';
import { usePersistentFiltering } from 'Lib/hooks/usePersistentFiltering';
import { useEffect } from 'react';
import { CHARGE_ALLOCATION_STATUS } from './Enum';
import { useTransactionAndChargeAllocationContext } from './TransactionAndChargesContext';
import TransactionLanding from './TransactionLanding';

const ReconcileView = () => {
  const [globalState] = useGlobalState();

  const [persistentFilter, updateFilterField] = usePersistentFiltering(
    `CA_FILTER`,
    {
      status: [CHARGE_ALLOCATION_STATUS.OPEN, CHARGE_ALLOCATION_STATUS.PENDING],
    },
  );

  let title = (
    <span>
      Reconcile <FilterIndicator />
    </span>
  );

  const { getHeaders, getDataTable, resetState } =
    useTransactionAndChargeAllocationContext(updateFilterField);

  useEffect(() => {
    resetState();
  }, []);

  let HEADERS = getHeaders({
    persistentFilter,
    updateFilterField,
    fromState: { fromReconcile: true },
  });

  const headers = [
    HEADERS.REF_NUMBER,
    HEADERS.DATE_ENTERED,
    HEADERS.CORE_FACILITY,
    HEADERS.VENDOR,
    HEADERS.DESCRIPTION,
    HEADERS.CATEGORY,
    HEADERS.TYPE,
    HEADERS.ACCOUNT,
    HEADERS.EXPENSE_CODE,
    HEADERS.AMOUNT,
    HEADERS.DATE_CLEARED,
    HEADERS.RECONCILER,
    HEADERS.STATUS,
  ];

  let breadcrumb = [SITE_PAGES.TRANSACTION_LANDING, SITE_PAGES.RECONCILE];

  let pageContent = getDataTable({
    title,
    dataKey: 'CA',
    dataQueryFunction: ChargeAllocationData.getCAListFunction(
      globalState.fiscalYear,
    ),
    dataExportFunction: ChargeAllocationData.getExportCAListFunction(
      globalState.fiscalYear,
    ),
    persistentFilter,
    updateFilterField,
    headers,
  });

  return (
    <TransactionLanding breadcrumbs={breadcrumb}>
      {pageContent}
    </TransactionLanding>
  );
};

export default ReconcileView;
